import AsyncButton from '#/components/async-button/component';
import {ReactComponent as UsdcIcon} from '#/components/icons/usdc-icon.svg';
import {useWalletProvider} from '#/contexts/wallet-provider';
import environment from '#/environment/environment';
import {useAddFundsAction} from '#/hooks/use-add-funds-action';
import {useTranslation} from 'react-i18next';

export const BalanceCard = () => {
  const {usdCBalance} = useWalletProvider();
  const addFundsAction = useAddFundsAction();

  return (
    <>
      <div className='bg-graybluedark2 h-full flex items-center px-3 gap-2'>
        <div className='text-white flex gap-1 items-center'>
          <div className='w-5'>
            <UsdcIcon />
          </div>
          <div>{usdCBalance?.formattedValue}</div>
        </div>
        {environment.isWaitlistNet && (
          <div>
            <div
              onClick={addFundsAction}
              className='text-white text-2xl flex justify-center items-center bg-deepblue h-full pb-1 rounded hover:scale-105 transition-all ease-in-out cursor-pointer'
            >
              <div className='text-white h-5 w-6 text-2xl flex justify-center items-center bg-deepblue rounded hover:scale-105 transition-all ease-in-out cursor-pointer'>
                {/* eslint-disable-line react/jsx-no-literals*/}+
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export const MobileBalanceCard = () => {
  const {usdCBalance} = useWalletProvider();
  const addFundsAction = useAddFundsAction();
  const {t} = useTranslation('translation');

  return (
    <>
      <div className='bg-graybluedark2 h-full flex justify-between items-center px-3 gap-2'>
        <div className='text-white flex gap-1 items-center'>
          <div className='w-5'>
            <UsdcIcon />
          </div>
          <div>{usdCBalance?.formattedValue}</div>
        </div>
        <div>
          <AsyncButton className='h-8 @2xl/expandable-tile:text-sm' size='xs' onClick={addFundsAction}>
            {t('actions.addFunds')}
          </AsyncButton>
        </div>
      </div>
    </>
  );
};
